<template>
  <section class="border bg-white rounded-md p-3">
    <div class="text-xl font-bold">{{ $t('pages.game.table.label') }}</div>
    <h2 class="mt-1 text-sm text-slate-500">
      {{ $t('pages.game.table.heading', { home: game.home?.name, away: game.away?.name, date: useDate(game?.startDate).format('HH:mm YYYY-MM-DD') }) }}
    </h2>
    <div class="mt-3 overflow-hidden rounded border border-slate-200">
      <div
        v-for="(row, index) in tableRows"
        :key="row.label"
        :class="[
          'grid grid-cols-[1fr_2fr_1fr] items-center border-t border-slate-200 first:border-t-0 py-2',
          index % 2 === 0 ? 'bg-slate-100' : ''
        ]"
      >
        <span class="text-center font-bold">
          {{ row.homeValue }}
        </span>
        <span class="text-center max-sm:text-sm">
          {{ row.label }}
        </span>
        <span class="text-center font-bold">
          {{ row.awayValue }}
        </span>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  game: {
    type: Object,
    default: () => ({})
  }
})

const homeTableTotal = computed(() => props.game?.table?.home?.total || {})
const awayTableTotal = computed(() => props.game?.table?.away?.total || {})

const formatValue = (value, { prefix = '', suffix = '' } = {}) => {
  if (value === null || value === undefined || value === '') return '-'
  return `${prefix}${value}${suffix}`
}

const tableRows = computed(() => [
  {
    label: 'Position',
    homeValue: formatValue(homeTableTotal.value?.position, { prefix: '#' }),
    awayValue: formatValue(awayTableTotal.value?.position, { prefix: '#' })
  },
  {
    label: 'Points',
    homeValue: formatValue(homeTableTotal.value?.points, { suffix: 'p' }),
    awayValue: formatValue(awayTableTotal.value?.points, { suffix: 'p' })
  },
  {
    label: 'Games',
    homeValue: formatValue(homeTableTotal.value?.games),
    awayValue: formatValue(awayTableTotal.value?.games)
  },
  {
    label: 'Average Points',
    homeValue: formatValue(homeTableTotal.value?.averagePoints, { suffix: 'p' }),
    awayValue: formatValue(awayTableTotal.value?.averagePoints, { suffix: 'p' })
  },
  {
    label: 'Win Percentage',
    homeValue: formatValue(homeTableTotal.value?.winPercentage, { suffix: '%' }),
    awayValue: formatValue(awayTableTotal.value?.winPercentage, { suffix: '%' })
  },
  {
    label: 'Goal Diff',
    homeValue: formatValue(homeTableTotal.value?.goalDiff, { prefix: homeTableTotal.value?.goalDiff > 0 ? '+' : '' }),
    awayValue: formatValue(awayTableTotal.value?.goalDiff, { prefix: awayTableTotal.value?.goalDiff > 0 ? '+' : '' }),
  },
  {
    label: 'Average Goals Forward',
    homeValue: formatValue(homeTableTotal.value?.averageGoalsFor),
    awayValue: formatValue(awayTableTotal.value?.averageGoalsFor)
  },
  {
    label: 'Average Goals Against',
    homeValue: formatValue(homeTableTotal.value?.averageGoalsAgainst),
    awayValue: formatValue(awayTableTotal.value?.averageGoalsAgainst)
  }
])
</script>
